/**
 * Drag finite-state machine — TD-001 §4.7.3 / PRD-C TR4.
 *
 * Models the lifecycle of pointer-driven drag interactions on the whiteboard:
 * idle → (object drag | marquee | create | pan) → idle.
 * Wiring into InteractionController follows in P3 (PRD-D); this file ships only
 * the state machine and its transition table for unit-level verification.
 */
export type DragState = 'idle' | 'dragging-object' | 'dragging-create' | 'marquee' | 'panning';

export type DragEvent =
  | 'pointer-down-on-object'
  | 'pointer-down-on-empty'
  | 'pointer-down-with-tool'
  | 'pointer-down-spacebar'
  | 'pointer-move'
  | 'pointer-up'
  | 'escape';

export const DRAG_TRANSITIONS = {
  idle: {
    'pointer-down-on-object': 'dragging-object',
    'pointer-down-on-empty': 'marquee',
    'pointer-down-with-tool': 'dragging-create',
    'pointer-down-spacebar': 'panning',
  },
  'dragging-object': { 'pointer-up': 'idle', escape: 'idle' },
  'dragging-create': { 'pointer-up': 'idle', escape: 'idle' },
  marquee: { 'pointer-up': 'idle', escape: 'idle' },
  panning: { 'pointer-up': 'idle', escape: 'idle' },
} as const satisfies Readonly<Record<DragState, Partial<Record<DragEvent, DragState>>>>;
